import { pct } from '@shared/format';
import { starsFor } from '@shared/game/heat';
import { useLayoutEffect, useRef } from 'preact/hooks';
import { t } from '../i18n/ru';
import { useController } from '../state/context';
import { Check } from './Icons';
import { Modal } from './Modal';

const STAR_SLOTS = [1, 2, 3] as const;

/** «Карта полей»: все поля каталога, пройденные — с галочкой и звёздами лучшего результата. */
export function LevelsModal() {
  const c = useController();
  const boards = c.boards.value;
  const progress = c.progress.value;
  const current = c.game.value?.boardId;
  const done = c.passedCount.value;
  const close = () => c.closeModal();
  const grid = useRef<HTMLUListElement>(null);

  // Список может быть длинным — сразу показываем текущее поле, а не начало каталога
  useLayoutEffect(() => {
    const cur = grid.current?.querySelector<HTMLElement>('.lv.cur');
    cur?.focus({ preventScroll: true });
    cur?.scrollIntoView?.({ block: 'center' });
  }, []);

  return (
    <Modal labelId="levels-title" onClose={close}>
      <h2 id="levels-title">{t.levels.title}</h2>
      <div class="lv-sum" data-testid="levels-summary">
        <span>{t.levels.passed(done, boards.length)}</span>
        <div class="lv-bar" aria-hidden="true">
          <i style={{ width: `${boards.length ? (done / boards.length) * 100 : 0}%` }} />
        </div>
      </div>
      {boards.length === 0 && <p>{t.levels.empty}</p>}
      <ul class="lv-grid" ref={grid}>
        {boards.map((b, k) => {
          const p = progress[b.id];
          const stars = p?.heat != null ? starsFor('win', p.heat) : 0;
          const cls = ['lv', p ? 'done' : '', stars === 3 ? 'gold' : '', b.id === current ? 'cur' : '']
            .filter(Boolean)
            .join(' ');
          return (
            <li key={b.id}>
              <button
                type="button"
                class={cls}
                data-testid="level"
                data-board-id={b.id}
                data-passed={p ? 'true' : 'false'}
                data-stars={stars}
                aria-current={b.id === current ? 'true' : undefined}
                aria-label={t.levels.label(k + 1, b.title, stars, !!p)}
                style={{ '--k': k }}
                onClick={() => void c.pickBoard(b.id)}
              >
                <span class="lv-n">{k + 1}</span>
                <span class="lv-title">
                  {b.title}
                  {b.generated && <span aria-hidden="true"> ✨</span>}
                </span>
                <span class="lv-stars" aria-hidden="true">
                  {STAR_SLOTS.map((n) => (
                    <i class={n <= stars ? 'on' : ''} key={n}>
                      {n <= stars ? '★' : '☆'}
                    </i>
                  ))}
                  {p?.heat != null && <b>{pct(p.heat)}</b>}
                </span>
                {p && (
                  <span class="lv-check" aria-hidden="true">
                    <Check />
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
      <div class="btns">
        <button type="button" onClick={close}>
          {t.levels.close}
        </button>
      </div>
    </Modal>
  );
}
